import React from 'react';
import { useQuery } from 'react-query';

import { shopGroupsApi, shopsApi, usersApi } from 'api';
import { QueryKey } from 'enums';
import { ProcessFundsRequests } from 'features/funds-request';
import { useMeta, useShopsQuery, useUser } from 'hooks';

export const ActiveFundsRequests: React.FC = () => {
  const { data: users = [] } = useQuery(
    QueryKey.Users,
    usersApi.getAllWithPlatform,
  );
  const { role } = useUser();
  const { isShopGroupEnabled } = useMeta();

  const { data: shops = [] } = useShopsQuery(
    QueryKey.Shops,
    shopsApi.getAllAsRole(role),
  );

  const { data: shopGroups = [] } = useQuery(
    QueryKey.ShopGroups,
    shopGroupsApi.getAllAsRole(role),
  );

  return (
    <ProcessFundsRequests
      hideTitle
      users={users}
      shops={shops}
      shopGroups={isShopGroupEnabled ? shopGroups : undefined}
    />
  );
};
